var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("or-modal", {
    ref: "attach-assets-modal",
    staticClass: "attach-assets-modal",
    on: {
      close: function ($event) {
        return _vm.$emit("hide")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v("\n    " + _vm._s(_vm.$t("hitl.common.addFile")) + "\n  "),
          ]
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function () {
          return [
            _vm.isOpen
              ? _c("or-asset-manager", {
                  attrs: {
                    "auth-token": _vm.getToken,
                    "files-api-url": _vm.mediaURL,
                    "allow-search": false,
                    "allowed-file-types": _vm.allowedFileTypes,
                    "multi-select": _vm.multiSelect,
                    "use-files": true,
                  },
                  model: {
                    value: _vm.files,
                    callback: function ($$v) {
                      _vm.files = $$v
                    },
                    expression: "files",
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "actions" },
              [
                _c(
                  "or-button",
                  {
                    attrs: {
                      variant: _vm.ButtonVariant.Outlined,
                      "data-button": "reset",
                    },
                    on: { click: _vm.handleAttachReset },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("hitl.common.reset")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "or-button",
                  {
                    attrs: {
                      disabled: !_vm.canAttachFiles,
                      "data-button": "attach",
                    },
                    on: { click: _vm.handleAttachAccept },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("hitl.common.attachFile")) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }